import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-page--banner" }

import { onMounted, onUnmounted } from 'vue'

  interface Props {
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ibm',
  setup(__props: any) {

  const props = __props

  onMounted( ()  => {
  })

  onUnmounted( () => {
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"home-page--banner-container\" data-v-2a51480a><div class=\"home-page--banner-description\" data-v-2a51480a><h3 class=\"home-page--banner-description-heading\" data-v-2a51480a><a href=\"https://hakkoda.io/resources/hakkoda-an-ibm-company/\" class=\"home-page--banner-secondary-title\" data-v-2a51480a>Bigger Platform, Same Mission: <span class=\"home-page--banner-primary-title\" data-v-2a51480a>Hakkōda, an IBM Company</span></a> <a href=\"https://hakkoda.io/resources/hakkoda-an-ibm-company/\" class=\"home-page--banner-cta\" data-v-2a51480a> Read more &gt;</a></h3></div></div>", 1)
  ])))
}
}

})